import { takeEvery, call, put, all } from "redux-saga/effects";
import { api, queryBuilder, storage } from "services";

import authActions from "../actions/auth";

export function* GetMeRequest() {
    try {
        const { data } = yield call(api.request.get, queryBuilder("/auth/get-me", { include: "organizations" }));

        yield put(authActions.GetMe.success(data.success));
    } catch (error) {
        yield put(
            authActions.GetMe.failure({
                error,
            })
        );
    }
}

export function* LogoutRequest() {
    yield call(storage.remove, "token");
}

export function* SetTokenRequest(action) {
    yield call(storage.set, "token", action.payload);
}

export default function* root() {
    yield all([
        takeEvery(authActions.GetMe.TRIGGER, GetMeRequest),
        takeEvery(authActions.Logout.REQUEST, LogoutRequest),
        takeEvery(authActions.SetToken.REQUEST, SetTokenRequest),
    ]);
}
